import { AlertTriangle, AlertCircle, CheckCircle2, MinusCircle } from "lucide-react";

export const RISK_STYLES = {
  Mild: { bg: "#F0FDF4", text: "#15803D", border: "#86EFAC", Icon: CheckCircle2, label: "Mild" },
  Moderate: { bg: "#FFFBEB", text: "#B45309", border: "#FDE68A", Icon: AlertCircle, label: "Moderate" },
  High: { bg: "#FEF2F2", text: "#B91C1C", border: "#FCA5A5", Icon: AlertTriangle, label: "High" },
};

export const NONE_STYLE = { bg: "#F1F5F9", text: "#64748B", border: "#E2E8F0", Icon: MinusCircle, label: "Not screened" };

export const STATUSES = ["Not Indicated", "Recommended", "In Lab", "Report Available", "Reviewed"];

export const statusIndex = (s) => STATUSES.indexOf(s);

export function statusColor(status) {
  if (status === "Recommended") return { bg: "#EFF6FF", text: "#1E3A8A", border: "#BFDBFE" };
  if (status === "In Lab") return { bg: "#F5F3FF", text: "#5B21B6", border: "#DDD6FE" };
  if (status === "Report Available") return { bg: "#FEFCE8", text: "#854D0E", border: "#FDE68A" };
  if (status === "Reviewed") return { bg: "#F0FDF4", text: "#15803D", border: "#86EFAC" };
  return { bg: "#F1F5F9", text: "#64748B", border: "#E2E8F0" };
}
